import * as types from './types';
import { uiActions } from 'state/modules/UI';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import i18n from 'i18n-js';
//We are using SKUS pricing api module as the endpoint are the same
import * as skusApi from 'services/api/skus';

// GET CREDIT TYPES
const fetchCreditTypesRequest = () => ({
  type: types.FETCH_CREDIT_TYPES_REQUEST,
});

const fetchCreditTypesSuccess = (payload) => ({
  type: types.FETCH_CREDIT_TYPES_SUCCESS,
  payload,
});

const fetchCreditTypesFailed = (errors) => ({
  type: types.FETCH_CREDIT_TYPES_FAILED,
  errors,
});

export const fetchCreditTypes = (params, options) => {
  return async (dispatch) => {
    dispatch(fetchCreditTypesRequest());

    const response = await skusApi.fetchSkus(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchCreditTypesSuccess({
          data: response.data,
          pagination,
        })
      );
    }

    if (!isCancel(response)) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: getErrorMessage(response.data),
        })
      );
      dispatch(fetchCreditTypesFailed(response.data));
    }
  };
};

// CREATE CREDIT TYPE

const createCreditTypeRequest = () => ({
  type: types.CREATE_CREDIT_TYPE_REQUEST,
});

const createCreditTypeSuccess = (payload) => ({
  type: types.CREATE_CREDIT_TYPE_SUCCESS,
  payload,
});

const createCreditTypeFailed = () => ({
  type: types.CREATE_CREDIT_TYPE_FAILED,
});

export const createCreditType = (payload) => {
  return async (dispatch) => {
    dispatch(createCreditTypeRequest());

    const response = await skusApi.fetchCreateSku(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('credit_types.create_success'),
        })
      );
      return dispatch(createCreditTypeSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(createCreditTypeFailed());
  };
};

// UPDATE CREDIT TYPE

const updateCreditTypeRequest = () => ({
  type: types.UPDATE_CREDIT_TYPE_REQUEST,
});

const updateCreditTypeSuccess = (payload) => ({
  type: types.UPDATE_CREDIT_TYPE_SUCCESS,
  payload,
});

const updateCreditTypeFailed = (errors) => ({
  type: types.UPDATE_CREDIT_TYPE_FAILED,
  errors,
});

export const updateCreditTypeReset = (payload) => ({
  type: types.UPDATE_CREDIT_TYPE_RESET,
  payload,
});

export const updateCreditType = (id, payload) => {
  return async (dispatch) => {
    dispatch(updateCreditTypeRequest());

    const response = await skusApi.fetchUpdateSku(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('credit_types.update_success'),
        })
      );
      return dispatch(updateCreditTypeSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(updateCreditTypeFailed(response.data));
  };
};

// GET CREDIT TYPE BY ID
const fetchCreditTypeByIdRequest = () => ({
  type: types.FETCH_CREDIT_TYPE_BY_ID_REQUEST,
});

const fetchCreditTypeByIdSuccess = (payload) => ({
  type: types.FETCH_CREDIT_TYPE_BY_ID_SUCCESS,
  payload,
});

const fetchCreditTypeByIdFailed = (errors) => ({
  type: types.FETCH_CREDIT_TYPE_BY_ID_FAILED,
  errors,
});

export const fetchCreditTypeById = (id) => {
  return async (dispatch) => {
    dispatch(fetchCreditTypeByIdRequest());

    const response = await skusApi.fetchSkuById(id);

    if (response.ok) {
      return dispatch(
        fetchCreditTypeByIdSuccess({
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchCreditTypeByIdFailed(response.data));
  };
};

export const resetCreditType = () => ({
  type: types.RESET_CREDIT_TYPE,
});

// DELETE CREDIT TYPE

const deleteCreditTypeRequest = () => ({
  type: types.DELETE_CREDIT_TYPE_REQUEST,
});

const deleteCreditTypeSuccess = (payload) => ({
  type: types.DELETE_CREDIT_TYPE_SUCCESS,
  payload,
});

const deleteCreditTypeFailed = (errors) => ({
  type: types.DELETE_CREDIT_TYPE_FAILED,
  errors,
});

export const deleteCreditType = (id) => {
  return async (dispatch) => {
    dispatch(deleteCreditTypeRequest());

    const response = await skusApi.fetchDeleteSku(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('credit_types.delete_success'),
        })
      );
      return dispatch(deleteCreditTypeSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(deleteCreditTypeFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('credit_types.delete_failure'),
      })
    );

    return dispatch(deleteCreditTypeFailed(errors));
  };
};
